import { useState, useEffect } from "react";
import { ProdutoNFCeDto } from "./NFCe.Dto";

const CACHE_KEY = "nfceProdutos";

export function NFCeCodeLoad() {
  const [dataProdutoNFCe, setDataProdutoNFCe] = useState<ProdutoNFCeDto[]>([]);

  useEffect(() => {
    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      if (Array.isArray(parsedData)) {
        setDataProdutoNFCe(parsedData);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(CACHE_KEY, JSON.stringify(dataProdutoNFCe));
  }, [dataProdutoNFCe]);

  return [dataProdutoNFCe, setDataProdutoNFCe, CACHE_KEY] as const;
}
